module.exports = __webpack_public_path__ + "static/images/order-bg2.5545402.png";